import { ITelemetryItem } from '@microsoft/applicationinsights-web';

export const ScrubUpnInitializer = (envelope: ITelemetryItem) => {
  try {
    if (envelope && envelope.baseData) {
      if (envelope.name === 'Microsoft.ApplicationInsights.{0}.Pageview') {
        envelope = updateProp(envelope, 'uri');
      } else if (envelope.name === 'Microsoft.ApplicationInsights.{0}.RemoteDependency') {
        envelope = updateProp(envelope, 'name');
        envelope = updateProp(envelope, 'target');
      }
    }
  } catch (ex) {}
};

const obfuscateUpn = (input: string) => {
  return input.replace(/(\.|[a-z]|[A-Z]|[0-9])*(@|%40)(\.|[a-z]|[A-Z]|[0-9])*/g, '{USERID}');
};

const updateProp = (envelope: ITelemetryItem, prop: string) => {
  if (envelope && envelope.baseData) {
    var value = envelope.baseData[prop] as string;
    if (value) {
      envelope.baseData[prop] = obfuscateUpn(value);
      return envelope;
    }
  }
  return envelope;
};
